import { HelpTextMarkdown } from '@diagentech/exprworks-ui-components';
import React from 'react';

import { withPrivacyPolicyText, WithPrivacyPolicyTextProps } from '@/components/privacyPolicy/withPrivacyPolicyText';

interface PrivacyPolicyContentComponentProps extends WithPrivacyPolicyTextProps {}

export const PrivacyPolicyContentComponent: React.FC<PrivacyPolicyContentComponentProps> = ({ text }) => {
  return <HelpTextMarkdown id="privacy-policy" text={text} />;
};

export const PrivacyPolicyContent = withPrivacyPolicyText(PrivacyPolicyContentComponent);
